import React, { useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
} from "@mui/material";
import { MdDelete } from "react-icons/md";
import {
  useGetSalesQuery,
  useRemoveSalesMutation,
} from "../../../features/api/salesApi";
import { toast } from "react-toastify";
import { useGetProductQuery } from "../../../features/api/productApi";

const SalesRateRepeat = () => {
  const { data: pro } = useGetProductQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const products = pro?.products;

  const { data, error, isLoading } = useGetSalesQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const salesRepeat = data?.sales;

  const [removeSalesRate] = useRemoveSalesMutation();

  const handleDelete = async (id) => {
    const confirm = window.confirm("Are Your Sure?");
    if (confirm) {
      try {
        const result = await removeSalesRate(id);
        if (result) {
          toast.success("Delete Success..!!!");
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let getDate = day + "-" + month + "-" + year;
    return getDate;
  }

  return (
    <div>
      <div className="flex justify-between items-center px-12 my-4">
        <h1 className="text-xl font-bold">Sales Rate History</h1>
      </div>
      <div className="h-[75vh] overflow-auto max-w-sm lg:max-w-[960px] m-auto">
        {isLoading ? (
          <div className="w-fll h-screen flex flex-col items-center justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
          </div>
        ) : salesRepeat?.length === 0 ? (
          <p className=" text-xl text-red-500 mt-20 ml-20">
            There are no sales rate history
          </p>
        ) : (
          <TableContainer component={Paper}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <span className="font-bold">Sl No.</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Product</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Purchase Rate</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Sales Rate</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Date</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Action</span>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {salesRepeat
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  ?.map((row, i) => {
                    const proName = products?.find(
                      (pro) => pro?.id === +row?.name
                    );
                    return (
                      <TableRow key={row?.id}>
                        <TableCell>{i + 1}</TableCell>
                        <TableCell>{proName?.product_name}</TableCell>
                        <TableCell>{row?.unit_price}</TableCell>
                        <TableCell>{row?.sales_price}</TableCell>
                        <TableCell>{formatDate(row?.addDate)}</TableCell>
                        <TableCell className="">
                          <div className="flex items-center gap-x-4">
                            <span onClick={() => handleDelete(row?.id)}>
                              <MdDelete className="text-xl text-red-500 font-bold cursor-pointer" />
                            </span>
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[20, 30, 50]}
              component="div"
              count={salesRepeat?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        )}
      </div>
    </div>
  );
};

export default SalesRateRepeat;